export default "__VITE_ASSET__Mm3v$Ojs__"